import {useSelector} from "react-redux";
import React from "react";
import LeftSide from "../../components/Blocks/Leftside/LeftSide";
import AddQuestionContent from "../../components/Questions/AddQuestionContent";
import setPageTitle from "../../services/TitleService";
import UnathorizedRedirect from "../../services/UnathorizedRedirect";

export const AddQuestion = () => {
    const personinfo = useSelector(state => state.user.userInfo);
    UnathorizedRedirect(personinfo, 'Lecturer');
    setPageTitle('Add question');
    return (
        <div className="d-flex position-relative">
            <LeftSide key={Math.random()} personinfo={personinfo}/>
            <AddQuestionContent key={Math.random()} personinfo={personinfo}/>
        </div>
    )
}
export default AddQuestion;